module.exports = __webpack_public_path__ + "static/media/logoCIco.41b4d178.png";